// export interface IPubSub<TEvents> {
//   on(event: TEvents, cb: Function): PubSub<TEvents>
//   trigger(event: TEvents, ...args): PubSub<TEvents>
// }

type Register<T> = { [key in keyof T]: Array<Function> }

export class PubSub<TEvents> {
  events: TEvents

  /* eslint-disable-next-line */
  private register: Register<TEvents> = {} as Register<TEvents>
  /* eslint-disable-next-line */
  private oneRegister: Register<TEvents> = {} as Register<TEvents>

  one(event: keyof TEvents, cb: Function): PubSub<TEvents> {
    Array.isArray(this.oneRegister[event])
      ? this.oneRegister[event].push(cb)
      : (this.oneRegister[event] = [cb])

    return this
  }

  /**
   * The on() function will return a function that, if called, will cleanup itself up.
   * @param event
   * @param cb
   */
  on(event: keyof TEvents, cb: Function): Function {
    Array.isArray(this.register[event])
      ? this.register[event].push(cb)
      : (this.register[event] = [cb])

    return () => {
      this.off(event, cb)
    }
  }

  private off(event: keyof TEvents, cb: Function) {
    const eventCallbacks = this.register[event]
    const cbIndex = eventCallbacks.findIndex((callback) => {
      return callback === cb
    })

    if (cbIndex >= 0) {
      eventCallbacks.splice(cbIndex, 1)
    }
  }

  trigger(event: keyof TEvents, ...args): PubSub<TEvents> {
    if (!this.register[event] && !this.oneRegister[event]) {
      return this
    }

    while (this.oneRegister[event] && this.oneRegister[event].length) {
      const func = this.oneRegister[event].pop()
      if (typeof func === 'function') {
        func.apply(func, args)
      }
    }

    this.register[event] &&
      this.register[event].forEach(function (cb: Function): any {
        cb.apply(cb, args)
      })

    return this
  }
}
